
/*eslint-disable*/
import React from "react";

// reactstrap components
// import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

function AdminFooter() {
  return (
    <>
    
    </>
  );
}

export default AdminFooter;
